module.exports = __webpack_public_path__ + "img/img-ae086ae8.9887a6df.png";